/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import cornerstone from 'cornerstone-core';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../../../../store/store';
import { studies } from '@ohif/core';
import {
  setRefLines,
  setScrollType,
  setShowHistory,
  setCurrentTool,
  setLayoutElement,
  resetLayoutState,
  resetLayoutStateByElement,
  setIs3DModeEnabled,
  setIsMPRModeEnabled,
  updateLayoutElement
} from '../../../../../actions/LayoutActions';
import { changePatientToAnonym } from '../../../../../actions/ConfigActions';
import CornerstoneToolsUtils from '../../../../../model/CornerstoneToolsUtils';
import { ButtonGroup } from '../../../Common/styled/Button';
import {
  CreateButton,
  CreateToggleButton,
  CreateOptionsButton,
  CommonButtons,
  AcknowledgeButton,
  LogoutButton
} from '../../../Header/Toolbar/ToolbarButtons';
import { getToolset2D } from '../../../Header/Toolbar/getToolset2D';
import { stopMoviePlayer, startMoviePlayer } from '../../MoviePlayer';
import { sync, SyncRefLines } from '../../sync';
import useKeypressTools from '../../../../../util/useKeypressTools';
import {
  setLayout3DMode,
  setLayout3DModeMobile,
  setLayoutMPRMode,
  setLayoutMPRModeMobile
} from '../../Layout/LayoutUtils';
import { RENDER_TYPE_3D } from '../../../../../model/factoryRenderers';
import { screenShot, captureScreenShot, downloadScreenShot } from '../../../../../util/takeScreenShot';
import { getEnabledElement } from '../../../../../util/state';
import { isMobile } from 'react-device-detect';
import toolNames from '../../../Header/Toolbar/toolNames';
import GroupedTools from '../../../Header/Toolbar/GroupedTools';
import { useTranslation } from 'react-i18next';
import { CaptureDownloadDialog } from '../../../Common/CaptureDownloadDialog';
import {
  executeOnActiveViewport,
  getCrossWindowActiveViewport,
  getCrossWindowWindowId,
} from '../../crossWindow2dReferenceLines';

export const toolbar2d = ({ currentLayoutElement, config, layout }) => {
  const dispatch = useDispatch();
  const matchedProtocols = useSelector(
    (state) => state.protocols?.matchedProtocols || []
  );
  const [groupedTools, setGroupedTools] = useState(null);
  const [groupedToolsXPosition, setGroupedToolsXPosition] = useState(null);
  const [groupedToolsYPosition, setGroupedToolsYPosition] = useState(null);
  const [groupedToolsButtonTopPosition, setGroupedToolsButtonTopPosition] = useState(null);
  const [openGroupedToolsName, setOpenGroupedToolsName] = useState(null);
  const [showCaptureDownload, setShowCaptureDownload] = useState(false);
  const { t } = useTranslation();
  const handlerReset = async () => {
    CornerstoneToolsUtils.selectCornerstoneTool('Wwwc');
    window.cornerstoneTools.store.state.globalTools = {};
    dispatch(resetLayoutState());
    await studies.deleteStudyMetadataPromise(currentLayoutElement.StudyInstanceUID);
  };

  const handlerResetElement = () => {
    CornerstoneToolsUtils.selectCornerstoneTool('Wwwc');
    dispatch(setCurrentTool('Wwwc'));
    if (layout.elements.length === 1) {
      const element = getEnabledElement(layout.selectedViewIndex);
      cornerstone.reset(element);
      dispatch(resetLayoutStateByElement(element, layout.selectedViewIndex));
    }
    layout.elements.map((element, i) => {
      if (layout.viewsGroup.includes(i)) {
        const element = getEnabledElement(i);
        cornerstone.reset(element);
        dispatch(resetLayoutStateByElement(element, i));
      }
    });

    dispatch(updateLayoutElement(layout.selectedViewIndex, { isFixedWLPreset: false }));
  };

  const handlerSelectTool = (tool) => {
    const { viewsGroup, selectedViewIndex } = layout;
    const activeViewport = getCrossWindowActiveViewport();
    const isRemoteViewportActive = activeViewport
      && activeViewport.windowId !== getCrossWindowWindowId();
    if (isRemoteViewportActive && [toolNames.COPY_CAPTURE, toolNames.DOWNLOAD_CAPTURE].includes(tool.name)) {
      executeOnActiveViewport(tool.name, selectedViewIndex);
      return;
    }
    if (
      [toolNames.MODE_2D, toolNames.MODE_MPR, toolNames.MODE_3D].includes(tool.name)
      && activeViewport?.windowId !== getCrossWindowWindowId()
    ) {
      executeOnActiveViewport(tool.name, selectedViewIndex);
      return;
    }
    if (isRemoteViewportActive && [
      toolNames.MAGNIFY_PLUS,
      toolNames.CINE,
      toolNames.INVERT,
      toolNames.WL_PRESET,
    ].includes(tool.name)) {
      const commandOptions = tool.name === toolNames.WL_PRESET
        ? {
          windowCenter: tool.WLPreset?.data?.windowCenter,
          windowWidth: tool.WLPreset?.data?.windowWidth,
        }
        : undefined;
      executeOnActiveViewport(tool.name, selectedViewIndex, commandOptions);
      return;
    }
    if ([
      toolNames.ROTATE90,
      toolNames.ROTATE270,
      toolNames.HFLIP,
      toolNames.VFLIP,
      toolNames.RESET_POSITION,
      toolNames.ZOOM_1_TO_1,
      toolNames.ZOOM_FIT,
      toolNames.ZOOM_ACTUAL_SIZE,
    ].includes(tool.name)) {
      executeOnActiveViewport(tool.name, selectedViewIndex);
      return;
    }
    const cornerstoneElements = cornerstone.getEnabledElements();
    const currentCornerstoneElement = cornerstoneElements[layout.selectedViewIndex];

    // resetea lupa
    if (tool.name !== toolNames.MAGNIFY_PLUS) {
      cornerstoneElements.forEach((element) => {
        element &&
          CornerstoneToolsUtils.getCornerstoneTool('MagnifyPlus') &&
          CornerstoneToolsUtils.getCornerstoneTool('MagnifyPlus')._destroyMagnificationCanvas(
            element.element
          );
      });
    }

    if (
      tool.name !== toolNames.HISTORY
      && tool.name !== toolNames.GROUPED_TOOLS
      && tool.name !== toolNames.ROTATE_MENU
      && tool.name !== toolNames.ZOOM_MENU
      && layout.currentTool === tool.name
    ) return;

    if (tool.name !== toolNames.MAGNIFY_PLUS) {
      cornerstoneElements.forEach((element) => {
        element &&
          CornerstoneToolsUtils.getCornerstoneTool('MagnifyPlus') &&
          CornerstoneToolsUtils.getCornerstoneTool('MagnifyPlus')._destroyMagnificationCanvas(
            element.element
          );
      });
    }

    if (
      tool.name !== toolNames.HISTORY
      && tool.name !== toolNames.GROUPED_TOOLS
      && tool.name !== toolNames.ROTATE_MENU
      && tool.name !== toolNames.ZOOM_MENU
      && layout.currentTool === tool.name
    ) return;

    switch (tool.name) {
      case toolNames.GROUPED_TOOLS: {
        handleGroupedTools(tool);
        break;
      }
      case toolNames.ROTATE_MENU: {
        CornerstoneToolsUtils.selectCornerstoneTool(toolNames.ROTATE);
        dispatch(setCurrentTool(toolNames.ROTATE));
        sync();
        handleGroupedTools(tool);
        break;
      }
      case toolNames.ZOOM_MENU: {
        CornerstoneToolsUtils.selectCornerstoneTool(toolNames.ZOOM);
        dispatch(setCurrentTool(toolNames.ZOOM));
        sync();
        break;
      }
      case toolNames.MAGNIFY_PLUS: {
        const tool = window.cornerstoneTools.store.state.tools.find(
          (cTool) => cTool.name === 'MagnifyPlus'
        );
        tool.element = currentCornerstoneElement.element;
        window.cornerstoneTools.store.state.tools.push(tool);
        if (layout.elements[selectedViewIndex].isMagnifyingGlass) {
          window.cornerstoneTools.setToolDisabledForElement(
            currentCornerstoneElement.element,
            tool.name,
            { mouseButtonMask: 1 }
          );
          window.cornerstoneTools.setToolActiveForElement(
            currentCornerstoneElement.element,
            'Wwwc',
            { mouseButtonMask: 1 }
          );
        } else {
          window.cornerstoneTools.setToolActiveForElement(
            currentCornerstoneElement.element,
            tool.name,
            { mouseButtonMask: 1 }
          );
        }

        layout.elements[selectedViewIndex].isMagnifyingGlass =
          !layout.elements[selectedViewIndex].isMagnifyingGlass;

        dispatch(setLayoutElement(selectedViewIndex, layout.elements[selectedViewIndex]));
        break;
      }
      case toolNames.ANONYMIZE: {
        dispatch(changePatientToAnonym());
        break;
      }
      case toolNames.ANNOTATIONS: {
        break;
      }
      case toolNames.INFINITE_SCROLL: {
        dispatch(setScrollType());
        break;
      }
      case toolNames.COPY_CAPTURE: {
        screenShot(t);
        break;
      }
      case toolNames.DOWNLOAD_CAPTURE: {
        setShowCaptureDownload(true);
        break;
      }
      case toolNames.MODE_3D: {
        if (!currentLayoutElement.availableRenderers.find((item) => item === RENDER_TYPE_3D))
          return;

        dispatch(setIs3DModeEnabled(true));

        if (isMobile) {
          setLayout3DModeMobile(currentLayoutElement);
        } else {
          setLayout3DMode(currentLayoutElement);
        }
        break;
      }
      case toolNames.MODE_MPR: {
        if (!currentLayoutElement.availableRenderers.find((item) => item === RENDER_TYPE_3D))
          return;

        dispatch(setIsMPRModeEnabled(true));

        if (isMobile) {
          setLayoutMPRModeMobile(currentLayoutElement);
        } else {
          setLayoutMPRMode(currentLayoutElement);
        }
        dispatch(setCurrentTool(toolNames.CROSS_REFERENCE));
        break;
      }
      case toolNames.RESET: {
        handlerResetElement();
        sync();
        break;
      }
      case toolNames.WWWC_INPUT: {
        sync();
        break;
      }
      case toolNames.CINE: {
        if (viewsGroup.length > 0) {
          const isPlayingCine =
            layout.elements[layout.viewsGroup[0]] &&
            layout.elements[layout.viewsGroup[0]].isPlayingCine;

          viewsGroup.forEach((e) => {
            if (isPlayingCine !== null) {
              if (isPlayingCine) {
                stopMoviePlayer(e);
              } else {
                startMoviePlayer(e);
              }
              if (layout.elements[e]) {
                layout.elements[e].isPlayingCine = !isPlayingCine;
              }
              dispatch(setLayoutElement(e, layout.elements[e]));
            }
          });
        } else {
          if (layout.elements[selectedViewIndex].isPlayingCine) {
            stopMoviePlayer(selectedViewIndex);
          } else {
            startMoviePlayer(selectedViewIndex);
          }
          layout.elements[selectedViewIndex].isPlayingCine =
            !layout.elements[selectedViewIndex].isPlayingCine;
          dispatch(setLayoutElement(selectedViewIndex, layout.elements[selectedViewIndex]));
        }
        break;
      }
      case toolNames.REF_LINES: {
        dispatch(setRefLines());
        SyncRefLines();
        break;
      }
      case toolNames.INVERT: {
        layout.elements.forEach((element, i) => {
          if (layout.viewsGroup.includes(i)) {
            const element = getEnabledElement(i);
            const viewport = cornerstone.getViewport(element);
            viewport.invert = viewport.invert ? false : true;
            cornerstone.setViewport(element, viewport);
          }
        });
        break;
      }
      case toolNames.WL_PRESETS:
        break;
      case toolNames.WL_PRESET:
        changeWLPreset(tool.WLPreset);
        break;
      case toolNames.HISTORY:
        dispatch(setShowHistory(!store.getState().layout.showHistory));
        break;
      default: {
        CornerstoneToolsUtils.selectCornerstoneTool(tool.name);
        dispatch(setCurrentTool(tool.name));
        sync();
      }
    }
  };

  const handleGroupedTools = (tool) => {
    if (openGroupedToolsName !== tool.name) {
      const buttonBounds = tool.elementRef.current.getBoundingClientRect();
      setGroupedToolsXPosition(buttonBounds.x);
      setGroupedToolsYPosition(buttonBounds.bottom);
      setGroupedToolsButtonTopPosition(buttonBounds.top);
      setGroupedTools(tool.groupedTools);
      setOpenGroupedToolsName(tool.name);
    } else {
      setGroupedTools(null);
      setOpenGroupedToolsName(null);
    }
  };

  const closeGroupedTools = (tools) => {
    setGroupedTools(tools);
    if (!tools) setOpenGroupedToolsName(null);
  };

  const changeWLPreset = (WLPreset) => {
    const element = getEnabledElement(layout.selectedViewIndex);
    const viewport = cornerstone.getViewport(element);
    viewport.voi.windowCenter = WLPreset.data.windowCenter;
    viewport.voi.windowWidth = WLPreset.data.windowWidth;
    cornerstone.setViewport(element, viewport);
    dispatch(updateLayoutElement(layout.selectedViewIndex, { isFixedWLPreset: true }));
  };

  const toolset2D = getToolset2D(currentLayoutElement);

  useKeypressTools(toolset2D, handlerSelectTool);

  return (
    <>
      {groupedTools && (
        <GroupedTools
          tools={groupedTools}
          setGroupedTools={closeGroupedTools}
          groupedToolsXPosition={groupedToolsXPosition}
          groupedToolsYPosition={groupedToolsYPosition}
          groupedToolsButtonTopPosition={groupedToolsButtonTopPosition}
          currentTool={layout.currentTool}
          selectedElement={layout.elements[layout.selectedViewIndex]}
          handlerSelectTool={handlerSelectTool}
        />
      )}
      <ButtonGroup key="group">
        <CommonButtons config={config} layout={layout} handlerReset={handlerReset} />
        {toolset2D.map((tool, i) => {
          switch (tool.type) {
            case 'button':
              return (
                <React.Fragment key={`${tool.name}${i}`}>
                  <CreateButton
                    tool={tool}
                    currentTool={layout.currentTool}
                    handlerSelectTool={handlerSelectTool}
                  />
                </React.Fragment>
              );
            case 'toggle':
              return (
                <React.Fragment key={`${tool.name}${i}`}>
                  <CreateToggleButton
                    tool={tool}
                    currentTool={layout.currentTool}
                    selectedElement={layout.elements[layout.selectedViewIndex]}
                    handlerSelectTool={handlerSelectTool}
                  />
                </React.Fragment>
              );
            case 'options': {
              const resolvedOptions = typeof tool.options === 'function'
                ? tool.options(
                  tool.name === toolNames.HANGING_PROTOCOLS
                    ? matchedProtocols
                    : undefined
                )
                : tool.options;
              if (!resolvedOptions || resolvedOptions.length === 0) {
                return null;
              }
              return (
                <React.Fragment key={`${tool.name}${i}`}>
                  <CreateOptionsButton
                    tool={tool}
                    currentTool={layout.currentTool}
                    handlerSelectTool={handlerSelectTool}
                  />
                </React.Fragment>
              );
            }
            default:
              return <>{console.error('tool type is not correct')}</>;
          }
        })}
        <AcknowledgeButton config={config} />
        <LogoutButton />
      </ButtonGroup>
      <CaptureDownloadDialog
        open={showCaptureDownload}
        onClose={() => setShowCaptureDownload(false)}
        getCapture={captureScreenShot}
        onSubmit={downloadScreenShot}
      />
    </>
  );
};
